module.exports = __webpack_public_path__ + "static/Joshua_Taguicana_Resume-accee627d00a23cab6834b2d49062aa6.pdf";